import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDecimal
} from "pbas-vue-components";
import { translate2 } from "../trans2";
const headers = [
  new InMemoryHeader({
    title: "Id",
    type: new InMemoryString("Identifier"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title:
      "components.plan_builder.self_payment_settings.minimum_years_of_employment_including",
    type: new InMemoryDecimal("MinimumYearsOfEmploymentIncluding", {
      getString: (item, type) => {
        const value = item.MinimumYearsOfEmploymentIncluding;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return value.toFixed(0);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
    align: "left"
  }),
  new InMemoryHeader({
    title:
      "components.plan_builder.self_payment_settings.maximum_years_of_employment_excluding",
    type: new InMemoryDecimal("MaximumYearsOfEmploymentExcluding", {
      getString: (item, type) => {
        const value = item.MaximumYearsOfEmploymentExcluding;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return value.toFixed(0);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
    align: "left"
  }),
  new InMemoryHeader({
    title:
      "components.plan_builder.self_payment_settings.minimum_age_including",
    type: new InMemoryDecimal("MinimumAgeIncluding", {
      getString: (item, type) => {
        const value = item.MinimumAgeIncluding;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return value.toFixed(0);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title:
      "components.plan_builder.self_payment_settings.maximum_age_excluding",
    type: new InMemoryDecimal("MaximumAgeExcluding", {
      getString: (item, type) => {
        const value = item.MaximumAgeExcluding;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return value.toFixed(0);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.taxes.rate",
    type: new InMemoryDecimal("Rate", {
      getString: (item, type) => {
        const value = parseFloat(item.Rate);
        if (value === null || value === undefined || isNaN(value)) {
          return "";
        }
        return value.toFixed(2);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "globals.coverage",
    type: new InMemoryString(
      "CoverageIdentities[]/Current/Translations[]/Name",
      {
        getString: (item) => {
          return item.CoverageIdentities.map(
            (o) =>
              translate2(o.Current, "Name") +
              " (" +
              translate2(o.Current, "Description") +
              ")"
          ).join(", ");
        },
        getHtml: (item, type) => {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
      }
    ),
    sortable: false,
    visible: true,
    searchable: true,
  }),
];
export default headers;
